module.exports = __webpack_public_path__ + "static/media/news2.d8cc59b7.jpg";